/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomTxCardFieldDefinitionsCardWrite/view.blocks to change it.
import Alert from './Alert/index'
import CancelAction from './CancelAction/index'
import HideForFuture from './HideForFuture/index'
import Mandatory from './Mandatory/index'
import MultiValue from './MultiValue/index'
import Name from './Name/index'
import Number from './Number/index'
import React from 'react'
import ShortName from './ShortName/index'
import SubmitAction from './SubmitAction/index'
import Tracked from './Tracked/index'
import Type from './Type/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomTxCardFieldDefinitionsCardWrite({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite",
  onClose
  
}) {
  return (<React.Fragment
>
<TysiaModalHeader
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<div
  data-testid="DataVaxiomTxCardFieldDefinitionsCardWrite.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaModalHeaderTitle
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Edit treatment field"
/>
<TysiaModalHeaderCloseAction
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 onClose={onClose}
/>
</div>
)}
</TysiaModalHeader>
<TysiaModalContent
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<div
  data-testid="DataVaxiomTxCardFieldDefinitionsCardWrite.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<ShortName
  viewPath={`${viewPath}/ShortName`}
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Number
  viewPath={`${viewPath}/Number`}
/>
<Alert
  viewPath={`${viewPath}/Alert`}
/>
<HideForFuture
  viewPath={`${viewPath}/HideForFuture`}
/>
<MultiValue
  viewPath={`${viewPath}/MultiValue`}
/>
<Tracked
  viewPath={`${viewPath}/Tracked`}
/>
<Mandatory
  viewPath={`${viewPath}/Mandatory`}
/>
</div>
)}
</TysiaModalContent>
<TysiaModalFooter
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
{...childProps}
  viewPath={`${viewPath}/SubmitAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
{children}
</React.Fragment>)
}